import { Epic } from 'redux-observable';
import { ContactFields } from '@api';
import { IshState } from 'src/js/services/IshState';
import { OPEN_EDIT_CONTACT_REQUEST, setFieldsToState } from '../actions/Actions';
import CheckoutService from '../../../services/CheckoutService';
import { changePhase } from '../../../actions/Actions';
import { Phase } from '../../../reducers/State';
import { addContactToSummary } from '../../summary/actions/Actions';
import { Create, Request } from 'src/js/common/epics/EpicUtils';

const request: Request<ContactFields> = {
  type: OPEN_EDIT_CONTACT_REQUEST,
  getData: (contact, state) => CheckoutService.loadFields(contact, state),
  processData: (value, state) => {
    if (value.headings.length > 0 && state.checkout.contactAddProcess.contact.id) {
      return [
        setFieldsToState(value),
        changePhase(Phase.EditContact),
      ];
    } else {
      return [
        addContactToSummary(state.checkout.contactAddProcess.contact),
      ];
    }
  },
};

export const OpenEditContact: Epic<any, IshState> = Create(request);
